import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';

/**
 * Get patient data by room number following Android app's approach:
 * 1. Get all patient assignments from /hospital/patient/
 * 2. Find patient assigned to the specified room
 * 3. Fetch detailed patient data from HL7 API using patient_id
 * @param {string} roomNumber - Room number to find patient for
 * @returns {Promise} - Patient data with given_name, family_name, etc.
 */
function getPatientByReferenceId(reference_id, attributes) {
  const hl7Params = new URLSearchParams({
    reference_id: reference_id,
    attributes: attributes,
  });

  return httpService.get(`${ApiUrl.HL7_RECEIVER}?${hl7Params.toString()}`);
}

function getProfileSegments() {
  return httpService.get(ApiUrl.PROFILESEGMENT);
}

function getProfileFields() {
  return httpService.get(ApiUrl.PROFILEFIELD);
}

function getProfileSubFields() {
  return httpService.get(ApiUrl.PROFILESUBFIELD);
}

function buildHl7Attributes(segments = [], fields = []) {
  const names = [];
  segments.forEach((s) => {
    const segment=s['profile_segment']
    if (segment?.object && segment?.segment_name) names.push(segment.segment_name);
  });
  fields.forEach((f) => {
    const profile_field=f['profile_field']
    if (profile_field?.object && profile_field?.field_name) names.push(profile_field.field_name);
  });
  
  return names.join(',');
}

const obj = { getPatientByReferenceId, getProfileSegments, getProfileFields, getProfileSubFields, buildHl7Attributes };

export default obj;
